import getDictionaryReduxModule from '../../../utils/redux/getDictionaryReduxModule';
import Api from '../../../utils/resourcesApi';

const { constants, actions, reducer, sagas } = getDictionaryReduxModule('COUNTRIES', Api.countries.index);

export { constants, actions, reducer, sagas };
export default { constants, actions, reducer, sagas };

